import { BulkState } from '@/components/bulkQueue/tables/bulkContextUtils';
import { ProviderStore, createDefaultProviderStore } from '@/utils/store';

type BulkSelectionContextBaseValue = {
    isEntitySelectedStore: ProviderStore<boolean>;
    entityCount: number;
    submit: () => Promise<void>;
    state: BulkState;
    selectedCount: number;
};

export type BulkSelectionContextValue<T extends Record<string, unknown>> = T &
    BulkSelectionContextBaseValue;

export const BASE_VALUE: BulkSelectionContextBaseValue = {
    entityCount: 0,
    isEntitySelectedStore: createDefaultProviderStore(false),
    submit: async () => {
        // Do Nothing
    },
    state: 'idle',
    selectedCount: 0,
};
